import { render } from "./SsoWelcomePage.vue?vue&type=template&id=794ea3f2"
import script from "./SsoWelcomePage.vue?vue&type=script&lang=js"
export * from "./SsoWelcomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__